export default "__VITE_ASSET__DfsxM4h0__"